import { render, staticRenderFns } from "./TableActivities.vue?vue&type=template&id=1a1915e6&"
import script from "./TableActivities.vue?vue&type=script&lang=js&"
export * from "./TableActivities.vue?vue&type=script&lang=js&"
import style0 from "./TableActivities.vue?vue&type=style&index=0&id=1a1915e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports